import { Component, OnInit, Input } from '@angular/core';
import { IDosage } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractAddComponent } from '../../../../shared/abstracts/add/abstract-add/abstract-add.component';
import { FormGroup, FormControl, FormArray } from '@angular/forms';

@Component({
  selector: 'inc-dosage-add',
  templateUrl: './dosage-add.component.html',
  styleUrls: ['./dosage-add.component.scss'],
})
export class DosageAddComponent extends AbstractAddComponent<IDosage> implements OnInit {
  allDaysAreSelected = false;
  @Input() units: string[];
  @Input() periods: string[];
  @Input() days: { text: string, value: string }[];
  @Input() name: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.inData) {
      this.form.patchValue(this.inData);
      if (this.inData.timing && this.inData.timing.repeat && this.inData.timing.repeat.dayOfWeek) {
        this.form.get('timing.repeat.dayOfWeek').setValue(this.inData.timing.repeat.dayOfWeek);
      }
    }
  }

  save(inData: IDosage) {
    this.inData ? this.callUpdate.emit(inData) : this.callSave.emit(inData);
    this.form.reset(this.form.value);
  }

  resetForm() {
    return new FormGroup({
      timing: new FormGroup({
        repeat: new FormGroup({
          dayOfWeek: new FormControl(),
          periodUnit: new FormControl('daily')
        })
      }),
      doseAndRate: new FormArray([
        new FormGroup({
          doseQuantity: new FormGroup({
            value: new FormControl(''),
            currency: new FormControl('mg')
          }),
          rateQuantity: new FormGroup({
            value: new FormControl(''),
            currency: new FormControl('pill')
          })
        })
      ])
    });
  }

}
